import { supabase } from './supabase';

// This function will check if the people table exists in Supabase
export const setupSupabaseTable = async () => {
  try {
    // First, check if the table already exists
    const { data, error } = await supabase
      .from('people')
      .select('count(*)', { count: 'exact', head: true });
    
    if (!error) {
      console.log('Table "people" already exists');
      return true;
    }
    
    // If there's an error, it might be because the table doesn't exist
    // In this case, we'll create it using the Supabase SQL editor
    console.log('Table "people" does not exist or there was an error. Please create it manually in the Supabase dashboard.');
    console.log('SQL to create the table:');
    console.log(`
      CREATE TABLE public.people (
        id uuid PRIMARY KEY DEFAULT uuid_generate_v4(),
        name text NOT NULL,
        day text NOT NULL,
        location text NOT NULL,
        created_at timestamp with time zone DEFAULT now()
      );
      
      -- Enable Row Level Security
      ALTER TABLE public.people ENABLE ROW LEVEL SECURITY;
      
      -- Create policy to allow all operations
      CREATE POLICY "Allow all operations" ON public.people
        FOR ALL
        USING (true)
        WITH CHECK (true);
    `);
    
    // Return false to indicate that manual setup is needed
    return false;
  } catch (error) {
    console.error('Error checking if table exists:', error);
    return false;
  }
};

// This function will migrate existing data from localStorage to Supabase
export const migrateDataToSupabase = async () => {
  try {
    // First check if there's already data in Supabase
    const { count, error } = await supabase
      .from('people')
      .select('*', { count: 'exact', head: true });
    
    if (error) {
      console.error('Error checking for existing data:', error);
      return;
    }
    
    // If there's already data in Supabase, don't migrate
    if (count && count > 0) {
      console.log('Data already exists in Supabase, skipping migration');
      return;
    }
    
    // Get data from localStorage
    const puertoLaCruzData = localStorage.getItem('puertoLaCruzData');
    const margaritaData = localStorage.getItem('margaritaData');
    
    if (!puertoLaCruzData && !margaritaData) {
      console.log('No data to migrate');
      return;
    }
    
    // Process Puerto La Cruz data
    if (puertoLaCruzData) {
      const data = JSON.parse(puertoLaCruzData);
      
      for (const dayData of data) {
        const peopleToInsert = dayData.people.map((person: { name: string }) => ({
          name: person.name,
          day: dayData.day,
          location: 'puerto-la-cruz'
        }));
        
        if (peopleToInsert.length > 0) {
          const { error } = await supabase.from('people').insert(peopleToInsert);
          
          if (error) {
            console.error(`Error inserting Puerto La Cruz data for ${dayData.day}:`, error);
          }
        }
      }
    }
    
    // Process Margarita data
    if (margaritaData) {
      const data = JSON.parse(margaritaData);
      
      for (const dayData of data) {
        const peopleToInsert = dayData.people.map((person: { name: string }) => ({
          name: person.name,
          day: dayData.day,
          location: 'margarita'
        }));
        
        if (peopleToInsert.length > 0) {
          const { error } = await supabase.from('people').insert(peopleToInsert);
          
          if (error) {
            console.error(`Error inserting Margarita data for ${dayData.day}:`, error);
          }
        }
      }
    }
    
    console.log('Data migration completed');
  } catch (error) {
    console.error('Error migrating data:', error);
  }
}; 